import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { LayoutRouteProps, Navigate, Route } from 'react-router-dom';
import { Card, Skeleton } from 'antd';
import Header from './Header';

interface ProtectedRouteProps extends LayoutRouteProps {
    component: React.ComponentType;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ component: Component }) => {
  const { isAuthenticated, isLoading } = useAuth0()

  if (isLoading) {
    return (
      <>
        <Header />
        <Card className="w-56 h-44 m-8 shadow-md rounded-lg max-w-xs max-h-xs">
          <div className="flex flex-col items-center justify-center p-6">
            <Skeleton.Avatar active className="mb-4" />
            <Skeleton.Input active />
          </div>
        </Card>
      </>
    )
  }

  return isAuthenticated ? <Component /> : <Navigate to="/login" />
};

export default ProtectedRoute